import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function setSkyTexture(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;

	const { texture } = args;
	if (!texture || typeof texture !== 'string') {
		return {
			success: false,
			error: 'texture parameter is required and must be a string (e.g., "sky/overcast")'
		};
	}

	// Handle 'background' case - use solid color background
	if (texture === 'background') {
		if (threeInstance && threeInstance.clearSkyTexture) {
			threeInstance.clearSkyTexture();
		} else if (threeInstance && threeInstance.changeTexture) {
			// Fallback - set to background mode (uses 'Sky' with capital S)
			await threeInstance.changeTexture('Sky', 'background', null);
		}

		publish('sky_texture', 'changed', {
			ref: 'sky',
			old: null,
			new: 'background'
		});

		return { success: true, data: { texture: 'background' } };
	}

	// Validate texture key format for sky textures
	if (!texture.startsWith('sky/')) {
		return {
			success: false,
			error: 'texture must be "background" or start with "sky/" (e.g., "sky/overcast", "sky/sunrise")'
		};
	}

	// Apply sky texture via Three.js instance
	if (threeInstance && threeInstance.changeSkyTexture) {
		threeInstance.changeSkyTexture(texture);
	} else if (threeInstance && threeInstance.changeTexture) {
		// Fallback to legacy changeTexture method (uses 'Sky' with capital S)
		await threeInstance.changeTexture('Sky', texture, null);
	} else {
		return { success: false, error: 'Three.js instance not available or missing sky texture method' };
	}

	publish('sky_texture', 'changed', {
		ref: 'sky',
		old: null,
		new: texture
	});

	return { success: true, data: { texture } };
}

